import React, { Component } from "react";
import { map } from "lodash";
import CheckboxElement from "../UI/Checkbox";

let currentid = 3;
class OperationTeamPerformance extends Component {
  render() {
    const {
      data = {},
      handleChecks,
      allChecked,
      handleAllChecks,
      checkComponent
    } = this.props;

    checkComponent.some(data => data.value) === true
      ? checkComponent.map(function(data) {
          if (data.value === true) {
            currentid = data.id;
          }
          return currentid;
        })
      : (currentid = 3);
    return (
      <div className="col-xs-4">
        <div className="orange-cards checkbox-header">
          <div
            className="card-header"
            onChange={e =>
              handleAllChecks(e.target.value, e.target.id, e.target.checked)
            }
          >
            {currentid === 3 ? (
              <CheckboxElement
                heading
                inputChecked={allChecked}
                value="Operation_Team_Performance"
                id={3}
                disable={false}
                field="Operation Team Performance"
                label="Operation Team Performance"
              />
            ) : (
              <CheckboxElement
                heading
                value="Operation_Team_Performance"
                disable={true}
                inputChecked={false}
                field="Operation Team Performance"
                label="Operation Team Performance"
              />
            )}
          </div>
          <div className="card-content bottom-border">
            {map(data, elem => {
              return (
                <ul
                  key={elem.id}
                  onChange={e =>
                    handleChecks(
                      e.target.value,
                      e.target.id,
                      e.target.checked,
                      3,
                      "Operation_Team_Performance"
                    )
                  }
                >
                  {currentid === 3 ? (
                    <li className="mr-25 py-5">
                      <label className="flex-center-y pointer w-600">
                        <CheckboxElement
                          field={elem.title}
                          value={elem.req_name}
                          inputChecked={allChecked}
                          id={elem.id}
                          disable={false}
                          label={elem.title}
                        />
                      </label>
                    </li>
                  ) : (
                    <li className="mr-25 py-5">
                      <label className="flex-center-y pointer w-600">
                        <CheckboxElement
                          field={elem.title}
                          value={elem.req_name}
                          inputChecked={false}
                          id={elem.id}
                          disable={true}
                          label={elem.title}
                        />
                      </label>
                    </li>
                  )}
                </ul>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
export default OperationTeamPerformance;



// WEBPACK FOOTER //
// ./src/components/Management-dashboard/OperationTeamPerformance.js